import ConditionalDisplay from './Comparator';

const effectifConditional = new ConditionalDisplay({
  triggerId: 'effectif_de_l_entreprise',
  targetId: 'pourcentage_salaries_en_alternance_au_moins_5_pourcent_des_effectifs',
  expectedValue: '250 et plus',
});

effectifConditional.mount();

const ageEstimeConditional = new ConditionalDisplay({
  triggerId: 'connaissez_vous_la_date_de_naissance_de_votre_alternant',
  targetId: 'age_estime',
  expectedValue: 'non',
});
ageEstimeConditional.mount();

const dateNaissanceConditional = new ConditionalDisplay({
  triggerId: 'connaissez_vous_la_date_de_naissance_de_votre_alternant',
  targetId: 'date_de_naissance',
  expectedValue: 'oui',
});
dateNaissanceConditional.mount();

const situationAlternantConditional = new ConditionalDisplay({
  triggerId: 'connaissez_vous_le_profil_exact_du_beneficiaire',
  targetId: 'situation_de_l_alternant',
  expectedValue: 'Oui',
});
situationAlternantConditional.mount();

const dejaApprentiConditional = new ConditionalDisplay({
  triggerId: 'connaissez_vous_le_profil_exact_du_beneficiaire',
  targetId: 'deja_apprenti',
  expectedValue: 'Oui',
});
dejaApprentiConditional.mount();

const ruptureApprentiConditional = new ConditionalDisplay({
  triggerId: 'deja_apprenti',
  targetId: 'deja_apprenti_cas_de_rupture',
  expectedValue: 'Oui',
});
ruptureApprentiConditional.mount();

const diplomePrepareConditional = new ConditionalDisplay({
  triggerId: 'formation',
  targetId: 'diplome_prepare',
  expectedValue: 'Formation diplômante / titre RNCP',
});

diplomePrepareConditional.mount();

const formationDistanceConditional = new ConditionalDisplay({
  triggerId: 'formation',
  targetId: 'formation_theorique_realisee_a_80_pourcent_min_a_distance',
  expectedValue: 'Formation diplômante / titre RNCP',
});
formationDistanceConditional.mount();

const fieldsToShowIfDevisOui = [
  'apprentissage_cout_pedagogique_facture',
  'apprentissage_duree_totale_de_formation_en_mois',
  'professionnalisation_cout_pedagogique_facture',
  'professionnalisation_duree_totale_de_formation_en_mois',
  'professionnalisation_duree_totale_de_formation_en_heures',
];

fieldsToShowIfDevisOui.forEach((targetId) => {
  const conditional = new ConditionalDisplay({
    triggerId: 'devis_prestataire_de_formation',
    targetId,
    expectedValue: 'Oui',
  });
  conditional.mount();
});

//// Specific

// Date de naissance

const container = document.getElementById('date_de_naissance');
const ageEstimeInput = document.querySelector('#age_estime input[type="text"');

const ageMessageDate = document.querySelector('#date_de_naissance .js-26_passed');
const ageMessageEstime = document.querySelector('#age_estime .js-26_passed');

const more30MessageDate = document.querySelector('#date_de_naissance .js-more_30');
const more30MessageEstime = document.querySelector('#age_estime .js-more_30');

if ((container || ageEstimeInput) && (ageMessageDate || ageMessageEstime || more30MessageDate || more30MessageEstime)) {
  const dateInput = container?.querySelector('input[type="date"]');

  const checkboxValues = {
    // < 26 exceptions
    minima: document.querySelector('input[type="checkbox"][value="Bénéficiaire des minimas sociaux"]'),
    franceTravail1anPlus: document.querySelector('input[type="checkbox"][value="Inscrit à France travail depuis 1 an ou +"]'),
    franceTravailMoins1an: document.querySelector('input[type="checkbox"][value="Inscrit à France travail depuis - d\'1 an"]'),
    cui: document.querySelector('input[type="checkbox"][value="Ayant bénéficié d\'un contrat unique insertion (CUI)"]'),

    // > 30 exceptions
    handicap: document.querySelector('input[type="checkbox"][value="Reconnu travailleur handicapé"]'),
    sportif: document.querySelector('input[type="checkbox"][value="Sportif de haut niveau en reconversion"]'),
    entrepreneur: document.querySelector('input[type="checkbox"][value="Créateur ou repreneur d\'entreprise"]')
  };

  function isUnder26Exempt() {
    const { minima, franceTravail1anPlus, franceTravailMoins1an, cui } = checkboxValues;
    const combo1 = minima?.checked && franceTravail1anPlus?.checked && cui?.checked;
    const combo2 = minima?.checked && franceTravailMoins1an?.checked && cui?.checked;
    return combo1 || combo2;
  }

  function isOver30Exempt() {
    const { handicap, sportif, entrepreneur } = checkboxValues;
    return handicap?.checked && sportif?.checked && entrepreneur?.checked;
  }

  function updateMessageVisibility(age, targetMessage, type = '26') {
    if (age === null) {
      targetMessage?.setAttribute('hidden', '');
      return;
    }

    if (type === '26') {
      if (age >= 26 && !isUnder26Exempt()) {
        targetMessage?.removeAttribute('hidden');
      } else {
        targetMessage?.setAttribute('hidden', '');
      }
    }

    if (type === '30') {
      if (age > 30 && !isOver30Exempt()) {
        targetMessage?.removeAttribute('hidden');
      } else {
        targetMessage?.setAttribute('hidden', '');
      }
    }
  }

  function getAgeFromDate() {
    const value = dateInput?.value;
    if (!value) return null;

    const birthDate = new Date(value);
    const today = new Date();

    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }

    return age;
  }

  function getAgeFromText() {
    const value = ageEstimeInput?.value;
    const parsed = parseInt(value, 10);
    return isNaN(parsed) ? null : parsed;
  }

  function updateFromDateInput() {
    const age = getAgeFromDate();
    updateMessageVisibility(age, ageMessageDate, '26');
    updateMessageVisibility(age, more30MessageDate, '30');
  }

  function updateFromEstimeInput() {
    const age = getAgeFromText();
    updateMessageVisibility(age, ageMessageEstime, '26');
    updateMessageVisibility(age, more30MessageEstime, '30');
  }

  dateInput?.addEventListener('input', updateFromDateInput);
  ageEstimeInput?.addEventListener('input', updateFromEstimeInput);

  Object.values(checkboxValues).forEach((checkbox) => {
    checkbox?.addEventListener('change', () => {
      updateFromDateInput();
      updateFromEstimeInput();
    });
  });

  updateFromDateInput();
  updateFromEstimeInput();
}

// Apprentissage

const contratSelect = document.querySelector('#duree_contrat select');

const comparisons = [
  {
    inputSelector: '#apprentissage_duree_totale_de_formation_en_mois input[type="number"]',
    diffElementId: 'diff_than_6',
    longerElementId: 'less_than_contract',
  },
  {
    inputSelector: '#professionnalisation_duree_totale_de_formation_en_mois input[type="number"]',
    diffElementId: 'diff_than_6_pro',
    longerElementId: 'less_than_contract_pro',
  }
];

function checkAllDurations() {
  const contratValue = parseInt(contratSelect?.value);

  if (isNaN(contratValue)) {
    comparisons.forEach(({ diffElementId, longerElementId }) => {
      document.getElementById(diffElementId)?.setAttribute('hidden', '');
      document.getElementById(longerElementId)?.setAttribute('hidden', '');
    });
    return;
  }

  comparisons.forEach(({ inputSelector, diffElementId, longerElementId }) => {
    const input = document.querySelector(inputSelector);
    const value = parseInt(input?.value);

    const diffEl = document.getElementById(diffElementId);
    const longerEl = document.getElementById(longerElementId);

    if (isNaN(value)) {
      diffEl?.setAttribute('hidden', '');
      longerEl?.setAttribute('hidden', '');
      return;
    }

    const diff = Math.abs(contratValue - value);

    // Différence > 6 mois
    if (diff > 6) {
      diffEl?.removeAttribute('hidden');
    } else {
      diffEl?.setAttribute('hidden', '');
    }

    // Formation > contrat
    if (value > contratValue) {
      longerEl?.removeAttribute('hidden');
    } else {
      longerEl?.setAttribute('hidden', '');
    }
  });
}

function attachListeners() {
  comparisons.forEach(({ inputSelector }) => {
    const input = document.querySelector(inputSelector);
    if (!input) return;

    input.removeEventListener('input', checkAllDurations);
    input.removeEventListener('change', checkAllDurations);

    input.addEventListener('input', checkAllDurations);
    input.addEventListener('change', checkAllDurations);
  });
}

if (contratSelect) {
  contratSelect.addEventListener('change', checkAllDurations);
}

const observer = new MutationObserver(() => {
  attachListeners();
  checkAllDurations();
});

observer.observe(document.body, {
  childList: true,
  subtree: true,
});

attachListeners();
checkAllDurations();
